import React, { useContext, useState } from 'react'
import {Link} from 'react-router-dom'
import { Routes } from '../App'
import LPContext from '../lpLoader/LPContext';
import { USER_ROLE, getHighestPriviligeRoleLabel } from '../signin/RoleContext';
import Auth from '../services/Auth';
import { Collapse } from 'reactstrap';
import { FeatureFlags, FeatureFlagsType } from '../stores/FeatureFlag'


interface Props {
  message: string
  initials: string
  userRoles: USER_ROLE[]
  onSignout: () => void
}

const NavHeaderLayout = (props: Props) => {
  const lpContext = useContext(LPContext);
  const [isOpen, setIsOpen] = useState(false);
  const { reporting } = React.useContext(FeatureFlags) as FeatureFlagsType;

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <Link className="navbar-brand" to={Routes.Home}></Link>
      <button
        className="navbar-toggler"
        type="button"
        aria-controls="navbarText"
        aria-expanded="false"
        aria-label="Toggle navigation"
        onClick={ toggleMenu }>
        <span className="navbar-toggler-icon"></span>
      </button>
      <Collapse isOpen={isOpen} className="collapse navbar-collapse" id="navbarText">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item active"></li>
            </ul>
            <span className="navbar-text">
              <div className="info">
              {!isOpen && <div className="welcome">{props.message}</div>}
                <div>
                  {props.userRoles && (
                    <span className="btn btn-link" style={{ color: 'black' }}>
                      {`Signed in as: ${getHighestPriviligeRoleLabel(props.userRoles)}`}
                    </span>
                  )}
                  <span className="divider">|</span>
                  {Auth.checkRoleMembership([USER_ROLE.MANAGEUSERS, USER_ROLE.ADMIN]) ? <Link className="btn btn-link" to={`/accountAdmin/${lpContext.LP?.id > 0 ? lpContext.LP.id : ''}`}>
                    Account Administration
                  </Link> : <Link to={Routes.AccountSettings} className="btn btn-link">
                    Account Settings
                  </Link>}
              {reporting && Auth.checkRoleMembership([USER_ROLE.RUNREPORTS]) && <><span className="divider">|</span>
                    <a className="btn btn-link" href={Routes.Reports}>
                      Reports
                    </a></>}
                  <span className="divider">|</span>
                  <Link className="btn btn-link" to={Routes.Contact}>
                    Contact Us
                  </Link>
                  <span className="divider">|</span>
                  <Link className="btn btn-link" to={Routes.ARF}>
                    Request Appointment
                  </Link>
                  <span className="divider">|</span>
                  <Link className="btn btn-link" to={Routes.SignOut}>
                    Logout
                  </Link>
                </div>
          </div>
          {!isOpen && < div className="circle">
            <div>{props.initials}</div>
          </div>}
        </span>
      </Collapse>
    </nav>
  )
}

export default NavHeaderLayout
